import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
              <i className="ri-video-line"></i>
              视频爆料
            </div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              视频爆料
            </h2>
            <p className="text-sm text-foreground-500 mt-2">独家视频解读娱乐圈热门事件</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {mediaItems.map((item, idx) => (
              <div
                key={item.id}
                className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-primary-200 transition-all cursor-pointer"
              >
                <div className="relative overflow-hidden h-52">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    width="400"
                    height="260"
                  />
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors"></div>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform shadow-lg">
                      <i className="ri-play-fill text-2xl text-primary-500 ml-0.5"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-3 right-3 px-2.5 py-1 bg-background-950/80 rounded-full text-xs text-background-50">
                    {item.duration}
                  </div>
                  {idx === 0 && (
                    <div className="absolute top-3 left-3">
                      <span className="px-2 py-0.5 text-xs font-semibold text-background-50 bg-primary-500 rounded">
                        {item.tag}
                      </span>
                    </div>
                  )}
                </div>
                <div className="p-4">
                  <h3 className="font-sans font-bold text-base text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {item.views} 次播放
                    </span>
                    <span className="flex items-center gap-1 text-primary-500 cursor-pointer">
                      <i className="ri-share-forward-line"></i>
                      分享
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}